export default "__VITE_ASSET__g$r_heYS__"